module.exports = __webpack_public_path__ + "media/img/frontend_application/eventtype/dnd-e00b7b0bddb3bfb5eec466f2e263f28e.jpg";